module.exports = __webpack_public_path__ + "f93a0187e3843fc5174506152f49c11f.svg";